<template>
  <div class="report-log">
    <div class="search-wrap">
      <el-input class="search-val" v-model.trim="customerName" placeholder="请输入客户名称" clearable></el-input>
      <el-input class="search-val" v-model.trim="reportUserName" placeholder="请输入报备人" maxLength="11"
                clearable></el-input>
      <el-input class="search-val" v-model.trim="oldChargeName" placeholder="请输入原负责人" maxLength="11"
                clearable></el-input>
      <el-date-picker
          v-model="date"
          class="date-val"
          type="daterange"
          range-separator="至"
          start-placeholder="报备开始日期"
          end-placeholder="报备结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
          :default-time="['00:00:00', '23:59:59']"
      >
      </el-date-picker>
      <div class="operate-btns">
        <el-button type="primary" @click="onSearch" icon="el-icon-search">查询</el-button>
        <el-button plain @click="reset">重置</el-button>
      </div>
    </div>
    <div class="list-table">
      <new-table ref="linksRef" :data="tableData" :columns="columns" :pages="pages"></new-table>
    </div>

  </div>
</template>

<script>
import {CustomerApis} from "@/apis";
import NewTable from "@/components/new-table.vue";

export default {
  name: "report-log",
  components: {NewTable},
  created() {
    this.getLinks();
  },
  data() {
    return {
      customerName: "",//客户名称
      reportUserName: "",// 报备人
      oldChargeName: "",// 原负责人
      date: [],
      tableData: [],
      columns: [
        {
          label: "客户名称",  render: (h, {row}) => {
            return  <span  onClick={e=>this.customerDetail(row)} class="text-btn">{row.customerName}</span>
          }
        },
        {label: "报备人", prop: "reportUserName"},
        {label: "报备日期", width: 140, prop: "reportDate"},
        {label: "原负责人", prop: "oldChargeName"},
        {label: "原报备人", prop: "oldReportUserName"},
        {label: "原报备时间", width: 140, prop: "oldReportDate"},
        {label: "原报备到期时间", width: 140, prop: "oldReportEndDate"},
      ],
      pages: {
        props: {
          pageSize: 20,
          currentPage: 1,
          total: 0,
        },
        on: {
          "current-change": this.currentChange,
          "size-change": this.sizeChange,
        },
      },
    };
  },
  methods: {
    customerDetail(row){
      this.$router.push('/customer-detail?id='+row.customerId)
    },
    getLinks() {
      const params = {
        customerName: this.customerName,
        reportUserName: this.reportUserName,
        oldChargeName: this.oldChargeName,
        startDt: this.date && this.date[0],
        endDt: this.date && this.date[1],
        pageIndex: this.pages.props.currentPage,
        pageSize: this.pages.props.pageSize,
      };
      CustomerApis.customerReportLogPageList(params).then((res) => {
        this.tableData = res.data;
        this.pages.props.total = res.dataCount;
      });
    },
    onSearch() {
      this.currentChange(1);
    },
    reset() {
      this.customerName = "";
      this.reportUserName = "";
      this.oldChargeName = "";
      this.date = [];
      this.currentChange(1);
    },
    sizeChange(size) {
      this.pages.props.pageSize = size;
      this.currentChange(1);
    },
    currentChange(p) {
      this.pages.props.currentPage = p;
      this.getLinks();
    }
  },

};
</script>

<style scoped lang="scss">
.report-log {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.search-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .search-val {
    width: 170px;
    margin-right: 10px;
    margin-bottom: 18px;
  }

  .date-val {
    width: 270px;
    margin-right: 24px;
    margin-bottom: 18px;
  }

  .operate-btns {
    flex: 1;
    margin-bottom: 15px;
    min-width: 245px;
  }

  .right-btn {
    float: right;
  }
}

.operation-area {
  padding-bottom: 20px;
}

::v-deep {
  .text-btn {
    color: #3d9cfc;
    cursor: pointer;
  }
}
</style>
